export const RESET = 'EXCMDEVICEPERIPHERALDEVICE_LIST_RESET'
export const SET_ITEMS = 'EXCMDEVICEPERIPHERALDEVICE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDEVICEPERIPHERALDEVICE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDEVICEPERIPHERALDEVICE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDEVICEPERIPHERALDEVICE_LIST_TOGGLE_LOADING'
